import React, { useEffect, useState } from 'react';
import { Simulator } from './components/Simulator';
import { ErrorBoundary } from './components/ErrorBoundary';
export function App() {
  return <div className="min-h-screen bg-gradient-to-b from-[#000000] to-[#0F172A] text-white font-sans" data-id="element-0">
      <ErrorBoundary data-id="element-1">
        <Simulator data-id="element-2" />
      </ErrorBoundary>
    </div>;
}